import React from "react";
import ArrowTrainer from "./ArrowTrainer";

const DIRECTIONS_4 = ["up", "down", "left", "right"];

export default function Arrows4Page() {
  return (
    <ArrowTrainer
      directions={DIRECTIONS_4}
      titleKey="arrows"
      accent="cyan"
      testid="arrows-page"
    />
  );
}
